import { createEvent, createStore, EventCallable, Store } from 'effector';
import { HTMLAttributes, ReactElement } from 'react';

export type StatefulStore<T extends object> = { active: boolean } & Partial<T>;

export type StatefulProps<T extends object, K = object> = {
  state: Store<StatefulStore<T>>;
  setState: EventCallable<Partial<StatefulStore<T>>>;
} & HTMLAttributes<HTMLDivElement> &
  K;

export interface StatefulConfig {
  defaultState?: boolean;
}

export const createStateful = <T extends object = object, K = object>(
  component: (props: StatefulProps<T, K>) => ReactElement,
  config?: StatefulConfig,
) => {
  const $state = createStore<StatefulStore<T>>({
    active: config?.defaultState ?? false,
  } as StatefulStore<T>);
  const stateChanged = createEvent<Partial<StatefulStore<T>>>();

  $state.on(stateChanged, (state, payload) => ({
    ...state,
    ...payload,
  }));

  return {
    store: {
      $state,
      stateChanged,
    },
    Mount: (props: HTMLAttributes<HTMLDivElement> & K) =>
      component({ state: $state, setState: stateChanged, ...props }),
  };
};
